import { Radio as RadioPrimitive } from "@base-ui/react/radio";
import { RadioGroup as RadioGroupPrimitive } from "@base-ui/react/radio-group";
import * as React from "react";

import { cn } from "../../utils/cn";

function RadioGroup({
    className,
    ...props
}: RadioGroupPrimitive.Props): React.ReactElement {
    return (
        <RadioGroupPrimitive
            data-slot="radio-group"
            className={cn("grid w-full gap-2", className)}
            {...props}
        />
    );
}

function RadioGroupItem({
    className,
    ...props
}: RadioPrimitive.Root.Props): React.ReactElement {
    return (
        <RadioPrimitive.Root
            data-slot="radio-group-item"
            className={cn(
                "group/radio-group-item peer relative flex aspect-square size-4 shrink-0 rounded-full border border-line-base bg-surface-sunken",
                "after:absolute after:-inset-x-3 after:-inset-y-2",
                "transition-colors",
                // Base UI surfaces the disabled state via both the HTML
                // `disabled` attribute AND `data-disabled`. Cover both so the
                // hover/cursor/opacity overrides land regardless of which
                // Tailwind matches first. `pointer-events-none` is the
                // load-bearing piece that prevents `:hover` from triggering.
                "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
                "data-disabled:pointer-events-none data-disabled:cursor-not-allowed data-disabled:opacity-50",
                "aria-invalid:border-error-base aria-invalid:ring-[3px] aria-invalid:ring-status-error-200",
                "data-checked:border-accent",
                className
            )}
            {...props}
        >
            <RadioPrimitive.Indicator
                data-slot="radio-group-indicator"
                className="flex size-4 items-center justify-center"
            >
                <span className="absolute top-1/2 left-1/2 size-2 -translate-x-1/2 -translate-y-1/2 rounded-full bg-accent" />
            </RadioPrimitive.Indicator>
        </RadioPrimitive.Root>
    );
}

export { RadioGroup, RadioGroupItem };
